import PageGi1 from "./gi-1.jpg";
import PageGi2 from "./gi-2.jpg";
import PageGi3 from "./gi-3.jpg";
import PageGi4 from "./gi-4.jpg";
import PageGi5 from "./gi-5.jpg";
import PageGi6 from "./gi-6.jpg";
import PageGi7 from "./gi-7.jpg";
import PageGi8 from "./gi-8.jpg";
import PageGi9 from "./gi-9.jpg";
import LoadingGreen from "./loading-green.svg";
import PageLoader from "./page-load-loader.gif";
import PageProfileBg1 from "./profile-bg1.jpg";
import PageProfileBg2 from "./profile-bg2.png";
import PageProfileBg3 from "./profile-bg3.jpg";
import PageProfileBg4 from "./profile-bg4.jpg";
import PageProfileBg5 from "./profile-bg5.jpg";
import PageProfileBg6 from "./profile-bg6.jpg";
import PageProfileBg7 from "./profile-bg7.jpg";
import PageProfileBg8 from "./profile-bg8.jpg";
import PageProfileBg9 from "./profile-bg9.jpg";

export {
  PageLoader,
  PageProfileBg1,
  PageProfileBg2,
  PageProfileBg3,
  PageProfileBg4,
  PageProfileBg5,
  PageProfileBg6,
  PageProfileBg7,
  PageProfileBg8,
  PageProfileBg9,
  PageGi1,
  PageGi2,
  PageGi3,
  PageGi4,
  PageGi5,
  PageGi6,
  PageGi7,
  PageGi8,
  PageGi9,
  LoadingGreen,
};
